import {
    baseStates,
    baseMutations,
    baseActions,
    baseGetters,
} from '@/stores/base';

export const companySalesOtherPartTop = {

    namespaced: true,

    state:
    {
        ...baseStates,

        url: '/sales/other-parts/top',
    },

    mutations:
    {
        ...baseMutations,
    },

    actions:
    {
        ...baseActions,
    },

    getters:
    {
        ...baseGetters,
    },
};
